import { ValueOf } from '../utilities/types';

const formStates = {
  DRAFT: 'draft',
  PUBLISHED: 'published',
} as const;

export type FormStates = ValueOf<typeof formStates>;

export default formStates;
